import { Button } from "@/components/ui/button";
import { MapPin, ChevronRight, Loader2 } from "lucide-react";

export function NearbyWatersSection({ userLocation, nearbyDestinations, nearbyLoading, navigate }) {
  return (
    <section className="py-12 sm:py-16 bg-background" data-testid="nearby-waters-section">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6 px-4 sm:px-6">
          <div>
            <h2 className="font-serif text-2xl sm:text-3xl text-foreground">
              {userLocation ? "Top waters nearby" : "Featured destinations"}
            </h2>
            {userLocation && <p className="text-sm text-muted-foreground mt-1">Based on your location</p>}
          </div>
          <Button onClick={() => navigate('/destinations')} variant="ghost" className="text-primary hover:text-accent">
            View all<ChevronRight className="w-4 h-4 ml-1" />
          </Button>
        </div>

        {nearbyLoading ? (
          <div className="flex items-center justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-muted-foreground" /></div>
        ) : nearbyDestinations.length > 0 ? (
          <div className="overflow-x-auto scrollbar-hide pb-4">
            <div className="flex gap-4 px-4 sm:px-6" style={{ width: 'max-content' }}>
              {nearbyDestinations.slice(0, 8).map((dest, idx) => (
                <div
                  key={dest.id || idx}
                  onClick={() => navigate(`/destinations?destId=${dest.id}&view=map`)}
                  className="group cursor-pointer flex-shrink-0 w-[260px] sm:w-[280px]"
                >
                  <div className="aspect-[4/3] rounded-xl overflow-hidden mb-3 shadow-md">
                    <img
                      src={dest.image_url || `https://images.unsplash.com/photo-1541742481667-6a8cc8d402a3?w=400&q=80`}
                      alt={dest.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <h3 className="font-medium text-foreground group-hover:text-accent transition-colors truncate">{dest.name}</h3>
                  <p className="text-sm text-muted-foreground">{dest.state}</p>
                  {dest.water_type && <p className="text-xs text-muted-foreground capitalize">{dest.water_type}</p>}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-12 text-muted-foreground px-4">
            <MapPin className="w-8 h-8 mx-auto mb-2 opacity-50" /><p>No destinations found nearby</p>
          </div>
        )}
      </div>
    </section>
  );
}
